export type ImageDetail = {
  src: string;
  alt: string;
};

export const getCoverageImageDetail = (code: string): ImageDetail => {
  let image = { src: '', alt: '' };
  if (code === '0001') {
    image = {
      src: '/svg/bodily_injury.svg',
      alt: 'Bodily Injury',
    };
  }
  if (code === '0002') {
    image = {
      src: '/svg/carDemage.svg',
      alt: 'Car Demage',
    };
  }
  if (code === '0003') {
    image = {
      src: '/svg/medical_assistance.svg',
      alt: 'Medical Assistance',
    };
  }

  return image;
};
